<div class="view-champion-dialog">
  <div class="view-champion-dialog__content">
    <!-- Header -->
    <div class="view-champion-dialog__header">
      <div class="view-champion-dialog__title-section">
        <p class="view-champion-dialog__subtitle">{{ 'settings.champions.view_form.title' | translateLang }}</p>
        <h2 class="view-champion-dialog__title">{{ testimonial.organisationName }}</h2>
      </div>
      <p class="view-champion-dialog__description">
        {{ getDescription() }}
      </p>
      <div class="view-champion-dialog__info-banner">
        <p>{{ 'settings.champions.view_form.banner_text' | translateLang }}</p>
      </div>
    </div>

    <!-- Form Fields -->
    <div class="view-champion-dialog__form">
      <!-- Engagement Period -->
      <div class="view-champion-dialog__field-group">
        <label class="view-champion-dialog__label">{{ 'settings.champions.view_form.engagement_label' | translateLang }}</label>
        <div class="view-champion-dialog__field-row">
          <div class="view-champion-dialog__input-readonly">
            {{ testimonial.engagementMonth ? getMonthName(testimonial.engagementMonth) : ('settings.champions.not_available' | translateLang) }}
          </div>
          <div class="view-champion-dialog__input-readonly">
            {{ testimonial.engagementYear || ('settings.champions.not_available' | translateLang) }}
          </div>
        </div>
      </div>

      <!-- Testimonial -->
      <div class="view-champion-dialog__field-group">
        <label class="view-champion-dialog__label">{{ 'settings.champions.view_form.testimonial_label' | translateLang }}</label>
        <div class="view-champion-dialog__questions">
          <p>{{ 'settings.champions.view_form.testimonial_question_intro' | translateLang }}</p>
          <p>{{ 'settings.champions.view_form.testimonial_question_1' | translateLang }}</p>
          <p>{{ 'settings.champions.view_form.testimonial_question_2' | translateLang }}</p>
          <p>{{ 'settings.champions.view_form.testimonial_question_3' | translateLang }}</p>
        </div>
        <div class="view-champion-dialog__textarea-readonly">
          {{ testimonial.testimonial || ('settings.champions.view_form.no_testimonial' | translateLang) }}
        </div>
      </div>

      <!-- Duration -->
      <div class="view-champion-dialog__field-group">
        <label class="view-champion-dialog__label">
          {{ 'settings.champions.view_form.duration_label' | translateLang }}
        </label>
        <div class="view-champion-dialog__input-readonly">
          {{ testimonial.noOfMonthVisible ? (testimonial.noOfMonthVisible + ' ' + ('settings.champions.view_form.duration_months' | translateLang)) : ('') }}
        </div>
      </div>

      <!-- Media Upload -->
      <div class="view-champion-dialog__field-group">
        <label class="view-champion-dialog__label">{{ 'settings.champions.view_form.media_label' | translateLang }}</label>
        <div class="view-champion-dialog__input-readonly view-champion-dialog__input-readonly--media">
          @if (testimonial.media?.filename) {
            <span>{{ getFileName(testimonial.media!.filename) }}</span>
            <span class="view-champion-dialog__preview-link" (click)="openMediaPreview()">{{ 'settings.champions.view_form.preview' | translateLang }}</span>
          } @else {
            <span>{{ 'settings.champions.view_form.no_media' | translateLang }}</span>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Close Button -->
  <button class="view-champion-dialog__close-btn" (click)="close()" type="button" aria-label="Close">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#96080B"/>
      <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>
</div>
